import { Outlet } from 'react-router-dom';
import { Header } from '@/app/layouts/MainLayout/Header.tsx';
import { Footer } from '@/app/layouts/MainLayout/Footer.tsx';
import { ScrollToTop } from '@/app/layouts/utils/ScrollToTop.tsx';
import { ScrollToHash } from '@/app/layouts/utils/ScrollToHash.tsx';
import { RouteLoadingOverlay } from '@/app/layouts/utils/RouteLoadingOverlay.tsx';
import { usePostLoginVerificationRedirect } from '@/features/business';

/**
 * 마케팅/스토어/대시보드 등 일반 페이지에 적용되는 기본 레이아웃.
 * Header + main(Outlet) + Footer 구성.
 */
function MainLayout() {
  // 로그인 직후 1회: 미검증 기업 계정을 기업검증 화면으로 유도(one-shot).
  usePostLoginVerificationRedirect();

  return (
    <div className="flex min-h-screen w-full flex-col overflow-hidden">
      <ScrollToTop />
      <ScrollToHash />
      <RouteLoadingOverlay />
      <Header />

      <main className="relative z-10 flex-1 pt-16" style={{ minHeight: '80vh' }}>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export default MainLayout;
